// @flow

import moment from '@seek/moment-timezone-sydney';

export const getFormattedDate = (date: DateString) => {
  // Adding timeZone explicitly so that all date conversions are
  // Sydney time for both AU and NZ
  const dateObj = moment(date).tz('Australia/Sydney');
  return dateObj.locale('en-au').format('ll');
};
